import { NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB } from 'shared/hooks/experiments/useNewbuildingBuzzoolaIntegrationTestWebAvailable';

export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const DAILY_RENT_OTA_CONVERSION = 'dailyrent_web_sut375_online_booking_cr';
export const NB_LAYOUT_LISTING = 'newbuilding_layout_listing_inside_jk_desktop';
export const NB_RENT_TRAP = 'newbuilding_rent_trap_desktop';
export const NB_SUBURBAN_TRAP = 'newbuilding_suburban_trap_desktop';
export const NB_FLAT_SALE_TRAP = 'newbuilding_flatsale_trap_desktop';

export const BX_HYBRID_SEARCH_EXPERIMENT = 'vx_desktop_bx_863_hybrid_listing';

export const NEWBUILDING_MONTHLY_PAYMENT = 'newbuilding_monthly_payment_desktop';
export const AUD_DESKTOP_BX842_SEARCH_STRING_LISTING = 'aud_desktop_bx842_search_string_listing';

export const CPD_LABEL_EXPERIMENT = 'sel_cpd_label';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  RENTER_FORM_EXPERIMENT,
  DAILY_RENT_OTA_CONVERSION,
  NB_LAYOUT_LISTING,
  NB_RENT_TRAP,
  NB_SUBURBAN_TRAP,
  NB_FLAT_SALE_TRAP,
  /**
   * @todo Удалить переменную
   * @description Данный функционал появился в задаче CD-243377, будет удалён в задаче CD-245073
   */
  NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB,
  BX_HYBRID_SEARCH_EXPERIMENT,
  NEWBUILDING_MONTHLY_PAYMENT,
  AUD_DESKTOP_BX842_SEARCH_STRING_LISTING,
  CPD_LABEL_EXPERIMENT,
];
